import i18n from '@/shared/config/i18n'
import { DEFAULT_LOCALE } from '@/shared/config/constants'

const getLanguage = () => {
  const lang = localStorage.getItem('locale')
  if (lang === 'ko' || lang === 'en') return lang
  localStorage.setItem('locale', 'ko')
  return 'ko'
}

const changeLanguage = (lang: SupportedLocale) => {
  localStorage.setItem('locale', lang)
  i18n.global.locale = lang
  location.reload()
}

const setDefaultLanguage = (): SupportedLocale => {
  i18n.global.locale = (localStorage.getItem('locale') || DEFAULT_LOCALE) as SupportedLocale
  return i18n.global.locale
}

const translation = (test: string) => {
  return i18n.global.t(test)
}

export { getLanguage, changeLanguage, setDefaultLanguage, translation }
